import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { AppLoaderState } from './types';

const initState = () => {
    return new AppLoaderState();
};

export const useAppLoaderModule = createStoreModule<AppLoaderState, IAction<AppLoaderState>>(initState, 'app-loader');
